module.exports = __webpack_public_path__ + "img/banner.081784cb.jpg";